// extracted by mini-css-extract-plugin
export default {"cvError":"Z7-z"};